"use strict";
/*
author:gaokz
date:2018-05-10
 */
angular.module("planCommandMonitorManuscriptAnalysisModule", [
        "planCommandManuscriptAnalysisRouterModule",
        'manuscriptAnalysisNavModule',
        'planCommandMonitorRankingListModule',
        'planCommandMonitorCustomManuscriptPropModule',
        'planCommandMonitorManuscriptAnalysisAddEditcustomManuscriptPropModule'
    ])
    .controller("planCommandMonitorManuscriptAnalysisCtrl", ["$scope", "$location", function($scope, $location) {

    }]);